import { Classes, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'

const EmptyPlaceholder = ({ children = null, ...props }) => {
  if (children) {
    return children
  }
  return (
    <Icon className={Classes.TEXT_MUTED} icon={IconNames.MINUS} {...props} style={{ opacity: 0.3, ...props.style }} />
  )
}

export default EmptyPlaceholder
